const STAGES = [
  {
    title: "Requirement Planning",
    desc: "Determining and planning the specific warehouse needs of the company — location, size (area), budget and required facilities (e.g. cold storage, CCTV).",
  },
  {
    title: "RFP / RFQ Preparation",
    desc: "Preparing the detailed Request for Proposal document outlining all rules and guidelines — both Technical and Financial terms and conditions.",
  },
  {
    title: "Tender Notification",
    desc: "Inviting bids from eligible warehouse providers and vendors through a public notice — newspapers, the company website and official e-Tendering portals.",
  },
  {
    title: "Submission of Bids",
    desc: "Interested vendors submit official proposals under the Two-Bid System: 1. Technical Bid, 2. Financial Bid.",
  },
  {
    title: "Tender Evaluation",
    desc: "Applications reviewed by the selection committee — technical qualifications are verified first; financial bids are opened only for those who clear the technical round.",
  },
  {
    title: "Negotiation & Selection",
    desc: "Discussing terms with the shortlisted company offering the best price and high quality — negotiating price reduction and finalizing the Service Level Agreement (SLA).",
  },
  {
    title: "Award of Contract",
    desc: "Officially awarding the job and closing the tender process — issuing the Work Order, signing the legal agreement and collecting the security deposit.",
  },
];

const Process = () => (
  <section id="process" className="bg-surface text-ink py-24 border-b border-line" data-testid="process-section">
    <div className="max-w-7xl mx-auto px-6">
      <p className="font-mono text-xs uppercase text-brand tracking-widest mb-2">Tender Lifecycle</p>
      <h2 className="font-display text-[clamp(32px,4vw,56px)] uppercase mb-16 tracking-wide">
        Seven-Stage Bidding Protocol
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-testid="process-grid">
        {STAGES.map((stage, i) => (
          <div
            key={stage.title}
            className={`pt-6 border-t ${i === 0 ? "border-brand" : "border-line"}`}
            data-testid={`process-stage-${i + 1}`}
          >
            <span className="font-mono text-xs text-brand block mb-3">
              {String(i + 1).padStart(2, "0")}
            </span>
            <h3 className="text-base font-bold uppercase mb-2">{stage.title}</h3>
            <p className="text-xs text-mute leading-relaxed">{stage.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Process;
